// extracted by mini-css-extract-plugin
export default {"carousel":"JF-z"};